(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loose-pearls-pricing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(n){return '$'+Math.round(n).toLocaleString('en-AU');}
  function avail(v){return v!==null&&v!==undefined&&v>0;}
  var CARD_TYPES=['Australian South Sea','Tahitian','Akoya','Freshwater','Mabe','Keshi'];

  function init(root){
    var cardsEl=root.querySelector('[data-ep-cards]');
    var IMAGES={},PEARL_DATA=null,COLOURS={};
    var imgScript=root.querySelector('[data-ep-images]');
    if(imgScript){try{IMAGES=JSON.parse(imgScript.textContent);}catch(e){}}
    var priceScript=root.querySelector('[data-ep-prices]');
    if(priceScript){try{PEARL_DATA=JSON.parse(priceScript.textContent);}catch(e){}}
    var colourScript=root.querySelector('[data-ep-colours]');
    if(colourScript){try{COLOURS=JSON.parse(colourScript.textContent);}catch(e){}}

    // Non-trade: no price data was rendered. Show the cards only.
    if(!PEARL_DATA){
      if(cardsEl){
        CARD_TYPES.forEach(function(t){
          var short=t.replace('Australian ','');
          var url=IMAGES[t];
          var d=document.createElement('div');
          d.className='ep-card-btn';
          d.innerHTML=(url?'<img class="ep-card-img" src="'+url+'" alt="'+short+' pearls" loading="lazy">':'<span class="ep-card-ph">&nbsp;</span>')
            +'<span class="ep-card-name">'+short+'</span>';
          cardsEl.appendChild(d);
        });
      }
      return;
    }

    var typeSel=root.querySelector('[data-ep-type]'),shapeSel=root.querySelector('[data-ep-shape]'),unitSel=root.querySelector('[data-ep-unit]');
    var slider=root.querySelector('[data-ep-slider]'),dimEl=root.querySelector('[data-ep-dim]'),sizeEl=root.querySelector('[data-ep-size]');
    var gradesEl=root.querySelector('[data-ep-grades]'),rrpEl=root.querySelector('[data-ep-rrp]'),wsEl=root.querySelector('[data-ep-ws]');
    var typeNoteEl=root.querySelector('[data-ep-typenote]');
    var qtyEl=root.querySelector('.ep-qty'),addBtn=root.querySelector('[data-ep-add]'),modeBtns=root.querySelectorAll('[data-ep-mode]'),views=root.querySelectorAll('[data-ep-view]');
    var theadEl=root.querySelector('[data-ep-thead]'),tbodyEl=root.querySelector('[data-ep-tbody]');
    var addedEl=root.querySelector('[data-ep-added]');
    var colourFieldEl=root.querySelector('[data-ep-colour-field]'),swatchesEl=root.querySelector('[data-ep-swatches]'),colourSelectEl=root.querySelector('[data-ep-colour-select]');
    var colourValue='';
    var gradeIdx=0, showWs=root.dataset.showWholesale!=='false';
    if(!showWs) root.classList.add('ep-no-ws');

    function opts(sel,arr){sel.innerHTML=arr.map(function(o){return '<option>'+o+'</option>';}).join('');}
    function node(){return PEARL_DATA[typeSel.value][shapeSel.value][unitSel.value];}

    function renderColours(){
      if(!colourFieldEl)return;
      var conf=COLOURS[typeSel.value];
      if(!conf){colourFieldEl.hidden=true;colourValue='';return;}
      colourFieldEl.hidden=false;
      if(conf.type==='choice'){
        swatchesEl.hidden=true;
        colourSelectEl.hidden=false;
        opts(colourSelectEl,conf.options);
        if(conf.options.indexOf(colourValue)===-1)colourValue=conf.options[0];
        colourSelectEl.value=colourValue;
      }else{
        colourSelectEl.hidden=true;
        swatchesEl.hidden=false;
        var names=conf.options.map(function(o){return o.name;});
        if(names.indexOf(colourValue)===-1)colourValue=names[0];
        swatchesEl.innerHTML='';
        conf.options.forEach(function(o){
          var on=o.name===colourValue,b=document.createElement('button');
          b.type='button';
          b.className='ep-swatch-btn'+(on?' is-on':'');
          b.setAttribute('aria-label',o.name);
          b.title=o.name;
          if(o.image)b.style.backgroundImage="url('"+o.image+"')";
          b.addEventListener('click',function(){colourValue=o.name;renderColours();});
          swatchesEl.appendChild(b);
        });
      }
    }

    function onType(){opts(shapeSel,Object.keys(PEARL_DATA[typeSel.value]));colourValue='';renderColours();onShape();}
    function onShape(){opts(unitSel,Object.keys(PEARL_DATA[typeSel.value][shapeSel.value]));onUnit();}
    function onUnit(){var n=node();if(gradeIdx>=n.grades.length)gradeIdx=0;slider.max=n.sizes.length-1;if(+slider.value>n.sizes.length-1)slider.value=0;render();}
    function currentPrice(){var n=node();return n.sizes[+slider.value][1][gradeIdx];}

    function render(){
      var n=node(),si=+slider.value,row=n.sizes[si],prices=row[1];
      var single=n.sizes.length===1;
      slider.hidden=single;
      if(dimEl)dimEl.textContent=single?'Unit':'Size';
      if(typeNoteEl){
        if(n.note){typeNoteEl.textContent=n.note;typeNoteEl.hidden=false;}
        else{typeNoteEl.hidden=true;}
      }
      sizeEl.textContent=row[0];
      if(gradeIdx>=n.grades.length)gradeIdx=0;
      gradesEl.innerHTML='';
      n.grades.forEach(function(g,gi){
        var p=prices[gi],on=gi===gradeIdx,b=document.createElement('button');
        b.type='button';
        b.className='ep-chip'+(on?' is-on':'');
        b.innerHTML='<b>'+g+'</b><span>'+(avail(p)?money(p):'—')+'</span>';
        b.addEventListener('click',function(){if(avail(prices[gi])){gradeIdx=gi;render();}});
        gradesEl.appendChild(b);
      });
      var price=prices[gradeIdx];
      if(avail(price)){rrpEl.textContent=money(price);rrpEl.style.fontSize='';if(wsEl)wsEl.textContent=money(price/3);if(addBtn)addBtn.disabled=false;}
      else{rrpEl.textContent='Not offered';rrpEl.style.fontSize='1.6rem';if(wsEl)wsEl.textContent='—';if(addBtn)addBtn.disabled=true;}
      renderTable();
    }

    function renderTable(){
      var n=node(),g=n.grades;
      theadEl.innerHTML='<th>Size</th>'+g.map(function(x){return '<th>'+x+' RRP</th>';}).join('')+(showWs?'<th data-ep-th-ws>Wholesale</th>':'');
      tbodyEl.innerHTML=n.sizes.map(function(row){
        var cells='<td>'+row[0]+'</td>'+row[1].map(function(p){return '<td>'+(avail(p)?money(p):'—')+'</td>';}).join('');
        if(showWs){var first=row[1].find(avail);cells+='<td style="color:var(--ep-gold)">'+(first?money(first/3):'—')+'</td>';}
        return '<tr>'+cells+'</tr>';
      }).join('');
    }

    function add(){
      var n=node(),p=currentPrice();if(!avail(p)||!window.EPOrder)return;
      var typeShort=typeSel.value.replace('Australian ','');
      var specParts=[];
      if(colourValue)specParts.push(colourValue);
      specParts.push(shapeSel.value,unitSel.value,n.sizes[+slider.value][0],n.grades[gradeIdx]);
      var qty=Math.max(1,parseInt(qtyEl.value,10)||1);
      window.EPOrder.add({source:'loose-pearls',title:typeShort,spec:specParts.join(' · '),qty:qty,rrp:p,poa:false,url:location.pathname});
      if(addedEl){addedEl.hidden=false;clearTimeout(addedEl._t);addedEl._t=setTimeout(function(){addedEl.hidden=true;},4000);}
    }

    function renderCards(){
      if(!cardsEl)return;
      cardsEl.innerHTML='';
      CARD_TYPES.forEach(function(t){
        var has=!!PEARL_DATA[t];
        var on=(t===typeSel.value);
        var short=t.replace('Australian ','');
        var url=IMAGES[t];
        var b=document.createElement('button');
        b.type='button';
        b.className='ep-card-btn'+(on?' is-on':'');
        b.setAttribute('role','tab');
        b.setAttribute('aria-selected',on?'true':'false');
        if(!has){b.disabled=true;b.title=short+' pricing coming soon';}
        b.innerHTML=(url?'<img class="ep-card-img" src="'+url+'" alt="'+short+' pearls" loading="lazy">':'<span class="ep-card-ph">Add image</span>')
          +'<span class="ep-card-name">'+short+(has?'':'<br>Coming soon')+'</span>';
        b.addEventListener('click',function(){ if(!has)return; typeSel.value=t; onType(); renderCards(); });
        cardsEl.appendChild(b);
      });
    }

    slider.addEventListener('input',render);
    if(addBtn)addBtn.addEventListener('click',add);
    shapeSel.addEventListener('change',onShape);unitSel.addEventListener('change',onUnit);
    if(colourSelectEl)colourSelectEl.addEventListener('change',function(){colourValue=colourSelectEl.value;});
    modeBtns.forEach(function(btn){btn.addEventListener('click',function(){
      var m=btn.dataset.epMode;modeBtns.forEach(function(b){b.classList.toggle('is-on',b===btn);});
      views.forEach(function(v){v.hidden=v.dataset.epView!==m;});
    });});

    opts(typeSel,Object.keys(PEARL_DATA));
    if(root.dataset.defaultType&&PEARL_DATA[root.dataset.defaultType])typeSel.value=root.dataset.defaultType;
    onType();renderCards();
  }
  document.querySelectorAll('[data-ep]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-strands-pricing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(n){return '$'+Math.round(n).toLocaleString('en-AU');}
  function avail(v){return v!==null&&v!==undefined&&v>0;}
  var CARD_TYPES=['Australian South Sea','Tahitian','Akoya','Freshwater','Keshi'];

  function init(root){
    var cardsEl=root.querySelector('[data-eps-cards]');
    var IMAGES={},PEARL_DATA=null,COLOURS={};
    var imgScript=root.querySelector('[data-eps-images]');
    if(imgScript){try{IMAGES=JSON.parse(imgScript.textContent);}catch(e){}}
    var priceScript=root.querySelector('[data-eps-prices]');
    if(priceScript){try{PEARL_DATA=JSON.parse(priceScript.textContent);}catch(e){}}
    var colourScript=root.querySelector('[data-eps-colours]');
    if(colourScript){try{COLOURS=JSON.parse(colourScript.textContent);}catch(e){}}
    if(!PEARL_DATA)return;

    var typeSel=root.querySelector('[data-eps-type]'),shapeSel=root.querySelector('[data-eps-shape]');
    var slider=root.querySelector('[data-eps-slider]'),sizeEl=root.querySelector('[data-eps-size]');
    var gradesEl=root.querySelector('[data-eps-grades]'),rrpEl=root.querySelector('[data-eps-rrp]');
    var typeNoteEl=root.querySelector('[data-eps-typenote]');
    var qtyEl=root.querySelector('.eps-qty'),addBtn=root.querySelector('[data-eps-add]'),modeBtns=root.querySelectorAll('[data-eps-mode]'),views=root.querySelectorAll('[data-eps-view]');
    var theadEl=root.querySelector('[data-eps-thead]'),tbodyEl=root.querySelector('[data-eps-tbody]');
    var addedEl=root.querySelector('[data-eps-added]');
    var colourFieldEl=root.querySelector('[data-eps-colour-field]'),swatchesEl=root.querySelector('[data-eps-swatches]'),colourSelectEl=root.querySelector('[data-eps-colour-select]');
    var colourValue='';
    var gradeIdx=0;

    function opts(sel,arr){sel.innerHTML=arr.map(function(o){return '<option>'+o+'</option>';}).join('');}
    function leaf(){return PEARL_DATA[typeSel.value][shapeSel.value]['Strand'];}
    function pricedColours(){var l=leaf();return l&&l.colours?Object.keys(l.colours):null;}
    function node(){
      var l=leaf();
      if(l&&l.colours){return l.colours[colourValue]||l.colours[Object.keys(l.colours)[0]];}
      return l;
    }

    function renderColours(){
      if(!colourFieldEl)return;
      var conf=COLOURS[typeSel.value];
      if(!conf){colourFieldEl.hidden=true;colourValue='';return;}
      colourFieldEl.hidden=false;
      colourSelectEl.hidden=true;
      swatchesEl.hidden=false;
      // When this shape prices by colour, only offer the colours that actually have a grid.
      var priced=pricedColours();
      var options=priced?conf.options.filter(function(o){return priced.indexOf(o.name)>=0;}):conf.options;
      var names=options.map(function(o){return o.name;});
      if(names.indexOf(colourValue)===-1)colourValue=names[0];
      swatchesEl.innerHTML='';
      options.forEach(function(o){
        var on=o.name===colourValue,b=document.createElement('button');
        b.type='button';
        b.className='eps-swatch-btn'+(on?' is-on':'');
        b.setAttribute('aria-label',o.name);
        b.title=o.name;
        if(o.image)b.style.backgroundImage="url('"+o.image+"')";
        b.addEventListener('click',function(){colourValue=o.name;renderColours();if(pricedColours())recompute();});
        swatchesEl.appendChild(b);
      });
    }

    function onType(){opts(shapeSel,Object.keys(PEARL_DATA[typeSel.value]));colourValue='';onShape();}
    function recompute(){var n=node();if(gradeIdx>=n.grades.length)gradeIdx=0;slider.max=n.sizes.length-1;if(+slider.value>n.sizes.length-1)slider.value=0;render();}
    function onShape(){renderColours();recompute();}
    function currentPrice(){var n=node();return n.sizes[+slider.value][1][gradeIdx];}

    function render(){
      var n=node(),si=+slider.value,row=n.sizes[si],prices=row[1];
      var poa=!!n.pricing_poa;
      slider.hidden=n.sizes.length===1;
      if(typeNoteEl){
        if(n.note){typeNoteEl.textContent=n.note;typeNoteEl.hidden=false;}
        else{typeNoteEl.hidden=true;}
      }
      sizeEl.textContent=row[0];
      if(gradeIdx>=n.grades.length)gradeIdx=0;
      gradesEl.innerHTML='';
      n.grades.forEach(function(g,gi){
        var p=prices[gi],on=gi===gradeIdx,b=document.createElement('button');
        b.type='button';
        b.className='eps-chip'+(on?' is-on':'');
        var label=poa?'Enquire':(avail(p)?money(p):'—');
        b.innerHTML='<b>'+g+'</b><span>'+label+'</span>';
        b.addEventListener('click',function(){if(poa||avail(prices[gi])){gradeIdx=gi;render();}});
        gradesEl.appendChild(b);
      });
      var price=prices[gradeIdx];
      if(poa){rrpEl.textContent='Enquire';rrpEl.style.fontSize='2rem';if(addBtn)addBtn.disabled=false;}
      else if(avail(price)){rrpEl.textContent=money(price);rrpEl.style.fontSize='';if(addBtn)addBtn.disabled=false;}
      else{rrpEl.textContent='Not offered';rrpEl.style.fontSize='1.6rem';if(addBtn)addBtn.disabled=true;}
      renderTable();
    }

    function renderTable(){
      var n=node(),g=n.grades,poa=!!n.pricing_poa;
      theadEl.innerHTML='<th>Size</th>'+g.map(function(x){return '<th>'+x+'</th>';}).join('');
      tbodyEl.innerHTML=n.sizes.map(function(row){
        var cells='<td>'+row[0]+'</td>'+row[1].map(function(p){return '<td>'+(poa?'Enquire':(avail(p)?money(p):'—'))+'</td>';}).join('');
        return '<tr>'+cells+'</tr>';
      }).join('');
    }


    function add(){
      var n=node(),poa=!!n.pricing_poa,p=currentPrice();
      if(!poa&&!avail(p))return;
      if(!window.EPOrder)return;
      var typeShort=typeSel.value.replace('Australian ','');
      var specParts=[];
      if(colourValue)specParts.push(colourValue);
      specParts.push(shapeSel.value,n.sizes[+slider.value][0],n.grades[gradeIdx]);
      var qty=Math.max(1,parseInt(qtyEl.value,10)||1);
      window.EPOrder.add({source:'strands',title:typeShort+' Strand',spec:specParts.join(' · '),qty:qty,rrp:poa?null:p,poa:poa,url:location.pathname});
      if(addedEl){addedEl.hidden=false;clearTimeout(addedEl._t);addedEl._t=setTimeout(function(){addedEl.hidden=true;},4000);}
    }

    function renderCards(){
      if(!cardsEl)return;
      cardsEl.innerHTML='';
      CARD_TYPES.forEach(function(t){
        var has=!!PEARL_DATA[t];
        var on=(t===typeSel.value);
        var short=t.replace('Australian ','');
        var url=IMAGES[t];
        var b=document.createElement('button');
        b.type='button';
        b.className='eps-card-btn'+(on?' is-on':'');
        b.setAttribute('role','tab');
        b.setAttribute('aria-selected',on?'true':'false');
        if(!has){b.disabled=true;b.title=short+' coming soon';}
        b.innerHTML=(url?'<img class="eps-card-img" src="'+url+'" alt="'+short+' strand" loading="lazy">':'<span class="eps-card-ph">&nbsp;</span>')
          +'<span class="eps-card-name">'+short+(has?'':'<br>Coming soon')+'</span>';
        b.addEventListener('click',function(){ if(!has)return; typeSel.value=t; onType(); renderCards(); });
        cardsEl.appendChild(b);
      });
    }

    slider.addEventListener('input',render);
    if(addBtn)addBtn.addEventListener('click',add);
    shapeSel.addEventListener('change',onShape);
    if(colourSelectEl)colourSelectEl.addEventListener('change',function(){colourValue=colourSelectEl.value;});
    modeBtns.forEach(function(btn){btn.addEventListener('click',function(){
      var m=btn.dataset.epsMode;modeBtns.forEach(function(b){b.classList.toggle('is-on',b===btn);});
      views.forEach(function(v){v.hidden=v.dataset.epsView!==m;});
    });});

    opts(typeSel,Object.keys(PEARL_DATA));
    if(root.dataset.defaultType&&PEARL_DATA[root.dataset.defaultType])typeSel.value=root.dataset.defaultType;
    onType();renderCards();
  }
  document.querySelectorAll('[data-eps]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
